<template>
    <div class="row">
        <div class="col-12">
            <h4>Contact</h4>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
            <form-input :placeholder="$t('COMPANYDATA.email')"
                        :elementID="'email'"
                        :containerClass="'form-group'"
                        :inputClass="'form-control-sm'"
                        :inputType="'text'"
                        :validator="$v.contact.email"
                        v-model="contact.email">
            </form-input>
        </div>
        
        <div class="col-12 col-md-6 col-lg-4">
            <form-input :placeholder="$t('COMPANYDATA.phone')"
                        :elementID="'phone'"
                        :containerClass="'form-group'"
                        :inputClass="'form-control-sm'"
                        :inputType="'text'"
                        :validator="$v.contact.phone"
                        v-model="contact.phone">
            </form-input>
        </div>
        
        
        <div class="col-12 col-md-6 col-lg-4">
            <form-input :placeholder="$t('COMPANYDATA.mobilePhone')"
                        :elementID="'mobilePhone'"
                        :containerClass="'form-group'"
                        :inputClass="'form-control-sm'"
                        :inputType="'text'"
                        :validator="$v.contact.mobilePhone"
                        v-model="contact.mobilePhone">
            </form-input>
        </div>
    </div>
</template>
<script>
import FormInput from '../../../../../Shared/UI/Form/FormInput.vue';
import { required, email, numeric } from 'vuelidate/lib/validators';

export default {
    name: 'contact-data',
    components: {FormInput},
    props: {
        contact: {}
    },
    validations: {
        contact: {
            email: {
                required,
                email
            },
            phone: {
                required,
                numeric
            },
            mobilePhone: {
                required,
                numeric
            }
        }
        
    }
};
</script>
